import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=5cf2008f&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"
import style0 from "./carousel.vue?vue&type=style&index=0&id=5cf2008f&prod&scoped=true&lang=css"
import style1 from "./carousel.vue?vue&type=style&index=1&id=5cf2008f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2008f",
  null
  
)

export default component.exports